import React, { useEffect, useState } from "react";
import Datetime from "@iftek/react-datetime";
import moment from "moment";
import "@iftek/react-datetime/css/react-datetime.css";
import CustomButton from "../../CustomButton";

export default function BaseTimePicker(props) {
    const { time, timeFormat = 'HH:mm A', onChange, ...rest } = props;
    const [selectedTime, setSelectedTime] = useState(moment());
    const [isOpen, setIsOpen] = useState(false);

    const handleChange = (time) => {
        setSelectedTime(time);
        onChange(time);
    };

    useEffect(() => {
        setSelectedTime(time);
    }, [time]);

    return (
        <div className="time-picker-wrapper">
            <CustomButton
                size='sm'
                onClick={() => setIsOpen(!isOpen)}
                variant="primary-outline"
                prefix="time-picker-toggle w-100"
            >
                {moment(selectedTime).format(timeFormat)}
            </CustomButton>
            {isOpen && (
                <Datetime
                    value={selectedTime}
                    onChange={handleChange}
                    dateFormat={false}
                    timeFormat={timeFormat}
                    inputProps={{ readOnly: true }}
                    open={true}
                    {...rest}
                />
            )}
        </div>
    );
}
